"use client";
import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import apiClient from "../../service/interceptor";
import { Loader } from "../../components";
import "./mr-analysis.css";

export default function MRAnalysis() {
  const today = new Date();
  const lastWeek = new Date();
  lastWeek.setDate(today.getDate() - 7);
  const formatDate = (date) => date.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState(formatDate(lastWeek));
  const [endDate, setEndDate] = useState(formatDate(today));
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [statics, setStatics] = useState([]);
  const [staticsOverall, setStaticsOverall] = useState([]);
  const [staticTabActive, setStaticTabActive] = useState(true);
  const [matricCalculations, setMatricCalculations] = useState({});


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setErrorMessage("");
      setCurrentPage(1); // Reset page
      const response = await apiClient.post(
        "v1/analytics/therapy/mrCode-analysis-patient-doctor",
        {
          fromDate: startDate,
          toDate: endDate,
        }
      );
      if (response.status === 200) {
        const responseData = response.data?.data || response.data;
        setStatics(responseData.statics || []);
        console.log(responseData.staticsOverall);
        setStaticsOverall(responseData.staticsOverall[0] || []);
        setMatricCalculations(responseData.matricCalculations || {});
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage("Something went wrong while fetching data.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(statics);
    XLSX.utils.book_append_sheet(workbook, worksheet, "MR Statics");
    XLSX.writeFile(workbook, "mr_analysis.xlsx");
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = statics.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(statics.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return isLoading ? (
    <Loader />
  ) : (
    <div>
      <div className="statistics-content">
        <div className="onboarding-filter-container">
          <div className="onboarding-filter-item">
            <label htmlFor="startDate">Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
                setErrorMessage("");
              }}
              className="date-input"
            />
          </div>
          <div className="onboarding-filter-item">
            <label htmlFor="endDate">End Date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
                setErrorMessage("");
              }}
              className="date-input"
            />
          </div>
          <div className="onboarding-filter-item">
            <div></div>
            <button onClick={fetchData} className="search-button">
              Search
            </button>
          </div>
        </div>
      </div>

      {errorMessage && <p className="error">{errorMessage}</p>}

      <div className="tab-navigation">
        <button
          className={`tab-button ${staticTabActive ? 'active' : ''}`}
          onClick={() => {
            setStaticTabActive(true);
          }}                            >
          Static
        </button>
        <button
          className={`tab-button ${!staticTabActive ? 'active' : ''}`}
          onClick={() => {
            setStaticTabActive(false);
          }}                            >
          Overall statics
        </button>

      </div>


      {staticTabActive && statics.length > 0 && (
        <>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  {Object.keys(statics[0]).map((key) => (
                    <th key={key}>{key.replace(/_/g, " ").toUpperCase()}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentItems.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((value, i) => (
                      <td key={i}>{value}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>

         
          </div>
          <div style={{display:"flex",justifyContent:"space-around"}}>
              <h4>Average patient  : {matricCalculations.avgPatientsCalc}</h4>
              <h4>Average doctor  : {matricCalculations.avgDoctorsCalc}</h4>
            </div>
          <div className="MR-filter-item">
            <button className="mr-search-button" onClick={handleDownload}>
              Download Excel
            </button>
          </div>

          <div className="pagination">
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index + 1}
                className={`page-button ${currentPage === index + 1 ? "active" : ""}`}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </>
      )}



      {!staticTabActive && <table className="pain-table">
        <thead>
          <tr>
            <th></th>
            <th>Number of MRs</th>
            <th>Registered patients</th>
            <th>Registered doctors</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total MRs with only registered patients</td>
            <td>{staticsOverall.referral_codes_only_used_by_patients}</td>
            <td>{staticsOverall.number_of_patients_used_referal_code}</td>
            <td></td>
          </tr>
          <tr>
            <td>Total MRS with only registered doctors	</td>
            <td>{staticsOverall.referral_codes_only_used_by_doctors
            }</td>
            <td></td>
            <td>{staticsOverall.number_of_doctors_used_referal_code
            }</td>
          </tr>
          <tr>
            <td>Total MRS with BOTH registered doctors and patients</td>
            <td>{staticsOverall.referral_codes_used_by_both}</td>
            <td>{staticsOverall.number_of_patients_used_referal_code_both
            }</td>
            <td>{staticsOverall.number_of_doctors_used_referal_code_both}</td>
          </tr>
          <tr>
            <td>Total</td>
            <td>{staticsOverall.referral_codes_only_used_by_patients + staticsOverall.referral_codes_only_used_by_doctors + staticsOverall.referral_codes_used_by_both}</td>
            <td>{staticsOverall.number_of_patients_used_referal_code +staticsOverall.number_of_patients_used_referal_code_both }</td>
            <td>{staticsOverall.number_of_doctors_used_referal_code +staticsOverall.number_of_doctors_used_referal_code_both  }</td>
          </tr>
        </tbody>
      </table>}




    </div>
  );
}
